import './bootstrap';
import $ from 'jquery/dist/jquery';
import 'select2/dist/js/select2.min.js';
import "select2/dist/css/select2.min.css";
import '../sass/select2-rtl.css';
import Sortable from 'sortablejs/modular/sortable.core.esm.js';

window.jQuery = $;
/*! Select2 4.1.0-rc.0 | https://github.com/select2/select2/blob/master/LICENSE.md */
!function(){if(jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd)var n=jQuery.fn.select2.amd;n.define("select2/i18n/ar",[],function(){return{errorLoading:function(){return"لا يمكن تحميل النتائج"},inputTooLong:function(n){return"الرجاء حذف "+(n.input.length-n.maximum)+" عناصر"},inputTooShort:function(n){return"الرجاء إضافة "+(n.minimum-n.input.length)+" عناصر"},loadingMore:function(){return"جاري تحميل نتائج إضافية..."},maximumSelected:function(n){return"تستطيع إختيار "+n.maximum+" بنود فقط"},noResults:function(){return"لم يتم العثور على أي نتائج"},searching:function(){return"جاري البحث…"},removeAllItems:function(){return"قم بإزالة كل العناصر"}}}),n.define,n.require}();

$(document).ready(function() {
    $('#expired').on('click', '.insert-row', function () {
        $(this).fadeOut();
        let row = $(this).parents('tr').html();
        $(this).prop('disabled', true);
        $(this).parents('tr').after('<tr>'+row+'</tr>');
    });

    $('.select2-field').select2({
        language: 'ar',
    });

    if ( null !== document.querySelector('.area-boxes') ) {
        Sortable.create(document.querySelector('.area-boxes'), {
            onStart: function (/**Event*/evt) {
                evt.item.classList.add('bordered');
            },
            onEnd: function (evt) {
                evt.item.classList.remove('bordered');
                var areasOrder = [];
                var boxes = document.querySelectorAll('.area-box');
                boxes.forEach(function ($el) {
                    areasOrder.push( $el.dataset.id );
                });
                fetch('/save-areas', {
                    method: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    body: JSON.stringify( { areasOrder } )
                } );
            },
        });
    }
});
